import { render, staticRenderFns } from "./BoxRelationRequired.vue?vue&type=template&id=23d2b826&scoped=true&"
import script from "./BoxRelationRequired.vue?vue&type=script&lang=ts&"
export * from "./BoxRelationRequired.vue?vue&type=script&lang=ts&"
import style0 from "./BoxRelationRequired.vue?vue&type=style&index=0&id=23d2b826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2b826",
  null
  
)

export default component.exports